import React from 'react'
import ReactTooltip from 'react-tooltip'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import SettingsIcon from '@mui/icons-material/Settings'
import DownloadLS from '../Tools/DownloadLS'
import UploadLS from '../Tools/UploadLS'
import DownloadCSV from '../Tools/DownloadCSV'
import ClearLS from '../Tools/ClearLS'
import styled from '@emotion/styled'

const DialogContentRow = styled.div`
  margin: 10px 0;
`

export default function SettingMenu() {
  const [open, setOpen] = React.useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleOk = () => {
    setOpen(false)
  }

  return (
    <div>
      <Button
        className="settings-icon"
        data-tip
        data-for="registerTip"
        style={{}}
        onClick={handleOpen}
      >
        <ReactTooltip id="registerTip" place="bottom" effect="solid">
          Settings & Tools
        </ReactTooltip>
        <SettingsIcon style={{ color: 'white' }} />
      </Button>
      <Dialog disableEscapeKeyDown open={open} onClose={handleClose}>
        <DialogTitle id="form-dialog-title">Settings & Tools</DialogTitle>
        <DialogContent>
          <DialogContentRow>
            <DownloadLS />
          </DialogContentRow>
          <DialogContentRow>
            <UploadLS />
          </DialogContentRow>
          <DialogContentRow>
            <DownloadCSV />
          </DialogContentRow>
          <DialogContentRow>
            <ClearLS />
          </DialogContentRow>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleOk} color="primary">
            OK
          </Button>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
